import { render, staticRenderFns } from "./TabsSelector.vue?vue&type=template&id=67a0d4e8&scoped=true"
import script from "./TabsSelector.vue?vue&type=script&lang=js"
export * from "./TabsSelector.vue?vue&type=script&lang=js"
import style0 from "./TabsSelector.vue?vue&type=style&index=0&id=67a0d4e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0d4e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a0d4e8')) {
      api.createRecord('67a0d4e8', component.options)
    } else {
      api.reload('67a0d4e8', component.options)
    }
    module.hot.accept("./TabsSelector.vue?vue&type=template&id=67a0d4e8&scoped=true", function () {
      api.rerender('67a0d4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/history/components/TabsSelector.vue"
export default component.exports